
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.466 15.046a.79.79 0 00.571.237c.457 0 .8-.343.8-.8a.835.835 0 00-.229-.57L2.21 7.653l6.398-6.258c.141-.149.229-.36.229-.57a.788.788 0 00-.8-.81.79.79 0 00-.571.238L.505 7.065a.772.772 0 00-.264.59c0 .219.097.421.264.588l6.96 6.803z","fill":"#F9FAFB"}})])
          )
        }
      }
    